import { Outlet } from 'react-router';

export default function BuyProLayout() {
  return <Outlet />
}
